import { render, staticRenderFns } from "./OpenAccountSuccess.vue?vue&type=template&id=35c42136&scoped=true"
import script from "./OpenAccountSuccess.vue?vue&type=script&lang=js"
export * from "./OpenAccountSuccess.vue?vue&type=script&lang=js"
import style0 from "./OpenAccountSuccess.vue?vue&type=style&index=0&id=35c42136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c42136",
  null
  
)

export default component.exports